export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const WHATSAPP_NUMBER = "919217805401";

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const CONTACT = {
  email: "info@phudg.in",
  company: "ASAFU Consumer Goods",
  address: "Andheria Mor, Chattarpur, New Delhi – 110074",
  fssai: "23325002003228",
};

export const PRODUCT_LINKS = {
  "black-mustard-oil": {
    amazon: "https://www.amazon.in/Cold-Pressed-Mustard-Durable-Plastic-Traditional/dp/B0H26QLWPQ",
    instamart: "https://instamart.in/item/XQU3XDE1DN?share=true",
  },
  "yellow-mustard-oil": {
    amazon: "https://www.amazon.in/Pressed-Mustard-Traditional-Natural-Cooking/dp/B0H2QXRYWR",
    instamart: "https://instamart.in/item/SFNES3Z42G?share=true",
    blinkit: "https://blinkit.com/prn/x/prid/789997",
  },
  "sunflower-oil": {
    amazon: "https://www.amazon.in/Pressed-Sunflower-Unrefined-Traditional-Extracted/dp/B0H9M4GBZH",
  },
  "groundnut-oil": {
    amazon: "https://www.amazon.in/Wood-Pressed-Groundnut-Litre-Unrefined-Kachi/dp/B0HBKZMVGT",
  },
};

export const MARKETPLACES = {
  amazon: PRODUCT_LINKS["black-mustard-oil"].amazon,
  instamart: PRODUCT_LINKS["black-mustard-oil"].instamart,
  blinkit: PRODUCT_LINKS["yellow-mustard-oil"].blinkit,
};

export const SOCIAL = {
  instagram: "https://www.instagram.com/phudgofficial",
  facebook: "https://www.facebook.com/profile.php?id=61590527883516",
};

export const LAB_REPORTS = [
  { name: "Black Mustard Oil", url: "/lab-reports/black-mustard-oil.pdf", testid: "lab-report-black-mustard" },
  { name: "Yellow Mustard Oil", url: "/lab-reports/yellow-mustard-oil.pdf", testid: "lab-report-yellow-mustard" },
  { name: "Sunflower Oil", url: "/lab-reports/sunflower-oil.pdf", testid: "lab-report-sunflower" },
  { name: "Groundnut Oil", url: "/lab-reports/groundnut-oil.pdf", testid: "lab-report-groundnut" },
];
